import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ColorModule } from '../../color/color.module';

import { InputTextComponent } from './input-text.component';
import { InputTextLabelDirective, InputTextAddonLeftDirective, InputTextAddonRightDirective } from './input-text.directive';
export class InputTextModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    ColorModule,
    FormsModule
  ],
  exports: [InputTextComponent, InputTextLabelDirective, InputTextAddonLeftDirective, InputTextAddonRightDirective],
  declarations: [InputTextComponent, InputTextLabelDirective, InputTextAddonLeftDirective, InputTextAddonRightDirective]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function InputTextModule_tsickle_Closure_declarations() {
/** @type {?} */
InputTextModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputTextModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
